import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var StoreSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M121.51 384v-99.8a119.43 119.43 0 0 1-28 3.8 123.46 123.46 0 0 1-17.1-1.2 114.88 114.88 0 0 1-15.58-3.6V480c0 17.7 13.59 32 30.4 32h414.52L348.42 384zm-28-128.09c25.1 0 47.29-10.72 64-27.24L24 120.05c-30.52 53.39-2.45 126.53 56.49 135a95.68 95.68 0 0 0 12.99.86zm508.62 202.18-54.93-44.68V283.2a93.5 93.5 0 0 1-15.57 3.6 127.31 127.31 0 0 1-17.29 1.2 114.89 114.89 0 0 1-28-3.8v79.68L348.52 251.77a88.06 88.06 0 0 0 25.41 4.14c28.11 0 53-13 70.11-33.11 17.19 20.11 42.08 33.11 70.11 33.11a94.31 94.31 0 0 0 13-.91c59.66-8.41 88-82.8 56.06-136.4L521.55 15a30.1 30.1 0 0 0-25.74-15H112a30.11 30.11 0 0 0-25.73 15l-9.39 15.78-33.69-27.4a14.68 14.68 0 0 0-21.33 2.81L3.2 31.45a16.58 16.58 0 0 0 2.67 22.46l558.94 454.72a14.69 14.69 0 0 0 21.33-2.82l18.66-25.26a16.58 16.58 0 0 0-2.67-22.46z"
  }));
});
StoreSlash.displayName = 'StoreSlash';
export var StoreSlashDimensions = {
  height: 512,
  width: 640
};